import React from 'react';

import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AppHeader from '@components/AppHeader';

import { useMytaverse } from '@providers/MytaverseProvider';

import { useStyles } from './styles';

const PageNotFoundPage = () => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const { user } = useMytaverse();

  return (
    <>
      <AppHeader isAuthorized={!!user} />
      <Box sx={classes.content} component="div">
        <Typography sx={classes.title}>{translate('pageNotFound')}</Typography>
      </Box>
    </>
  );
};
export default PageNotFoundPage;
